import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'cp.pages.export.pageTitle',
    defaultMessage: 'Export Course',
  },
})
